module.exports = __webpack_public_path__ + "static/img/14.626a497.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/14.png
// module id = SlqN
// module chunks = 0